/**
 * Dashboard time-spent statistics.
 */
import React from "react";
import { Box, Grid } from '@mui/material';
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useMemo } from "react";

import { VText } from "form";
import { useAsterController } from "context";

/**
 * Charts recent learning and quiz time.
 */
const DashboardStatistic = () => {

  const { t, i18n } = useTranslation('common');

  const [controller] = useAsterController();
  const { courses, certificates, themes } = controller;
  const colorMain1 = useMemo(
    () => (themes || []).find((v) => v.name === "color_main1")?.value || "#E40473",
    [themes]
  );

  const [data, setData] = useState({});

  useEffect(() => {
    const enrolled = (courses.data || []).filter(v => v.enrollment_status);

    const currDate = new Date();
    const todo = enrolled.filter(v => currDate < new Date(v.enroll_end)).length;
    const overdue = enrolled.filter(v => currDate > new Date(v.enroll_end)).length;
    const completed = certificates.total;

    setData({ todo, overdue, completed, date: currDate.getDate(), month: currDate.toLocaleString(i18n.language === 'uk' ? 'us' : i18n.language, { month: 'short'}) });

  }, [courses.data, certificates.total, i18n.language]);

  return <Box className="w-10/12 mx-auto mt-5 px-4">
    <Box className="w-full flex justify-center sm:justify-start">
      <VText className="text-2xl">{t("Your Statistics")}</VText>
    </Box>
    <Box className="flex flex-col md:flex-row mt-4">
      <Grid container spacing={3}>
        {[
          { key: "todo", value: data.todo || "0", label: t("Todo"), icon: "mdi:clipboard-text-outline" },
          { key: "overdue", value: data.overdue || "0", label: t("Overdue"), icon: "mdi:clock-outline" },
          { key: "completed", value: data.completed || "0", label: t("Completed"), icon: "mdi:school-outline" },
          { key: "date", value: `${data.date || "0"} ${data.month || ""}`, label: t("Date"), icon: "mdi:calendar-blank-outline" },
        ].map((card) => (
          <Grid item xs={12} sm={6} lg={3} key={card.key}>
            <Box
              className="relative overflow-hidden rounded-lg w-full"
              sx={{
                aspectRatio: "290 / 117",
                background: `linear-gradient(115deg, ${colorMain1} 0%, color-mix(in srgb, ${colorMain1} 72%, #000) 100%)`,
              }}
            >
              <Icon icon={card.icon} className="absolute text-white opacity-40" width="30%" height="88" style={{ right: 8, top: "50%", transform: "translateY(-50%)" }} />
              <Box className="relative z-10 flex flex-col justify-center h-full pl-4 pr-24">
                <VText div className="text-4xl font-bold capitalize" color="white">{card.value}</VText>
                <VText className="text-lg" color="white">{card.label}</VText>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>;
};

export default DashboardStatistic;